import {
    createContext,
    ReactNode,
    useContext,
    useState,
  } from "react";
  
  import { IMaintenance } from "interfaces/Maintenance";
  import { getMaintenance } from "services/MaintenanceService";
  
  type FormError = { [key: string]: string };
  
  type ContextProviderProps = {
    children: ReactNode;
  };
  
  type ContextData = {
    maintenance: IMaintenance;
    setMaintenance: React.Dispatch<React.SetStateAction<IMaintenance>>;
    errors: FormError;
    setErrors: React.Dispatch<React.SetStateAction<FormError>>;
    removeError: (field: string) => void;
    retrieveMaintenance: (id: string) => void;
    resetMaintenance: () => void;
    searching: boolean;
    addError: (field: string, message: string) => void;
  };
  
  export const MaintenanceContext = createContext({} as ContextData);
  
  export function MaintenanceRegisterProvider({
    children,
  }: ContextProviderProps): JSX.Element {
    const [maintenance, setMaintenance] = useState<IMaintenance>(
      {isHeavy:true} as IMaintenance
    );
  
    const [errors, setErrors] = useState<FormError>({});
    const [searching, setSearching] = useState<boolean>(false);
  
    async function retrieveMaintenance(id: string) {
      setSearching(true);
      await getMaintenance(id)
        .then((res) => {
            setMaintenance(res.item);
            setSearching(false);
        })
        .catch((err) => {
            console.log(err);
            setSearching(false);
        });
    }
  
    function resetMaintenance() {
      setSearching(true);
      setMaintenance({isHeavy:true} as IMaintenance);
  
      setSearching(false);
    }
  
  
    function removeError(field: string) {
      setErrors((prev) => {
        delete prev[field]
  
        return {...prev}
      });
    }
    function addError(field: string, message: string) {
      const _errors = { ...errors };
      _errors[field] = message;
  
      setErrors(() => {
        return _errors;
      });
    }
    return (
      <MaintenanceContext.Provider
        value={{
          maintenance,
          setMaintenance,
          errors,
          setErrors,
          removeError,
          retrieveMaintenance,
          resetMaintenance,
          searching,
          addError
        }}
      >
        {children}
      </MaintenanceContext.Provider>
    );
  }
  
  export const useMaintenanceRegister = () => {
    return useContext(MaintenanceContext);
  };
  